import { SET_HELPERDETAIL } from '../actions';

const helperdetail = (state = [], action) => {
  switch (action.type) {
	case SET_HELPERDETAIL:
      return [...action.value];  
    default: return state;
  }
}

export default helperdetail;
